const $ = jQuery.noConflict();

'use strict';
/**
 * @description In order to create link that scrolls to certain section, simply place '#scroll-section-example' to a desired tag and id with same value to the section page should scroll to.
 * @description Alternately, you can enable any URL with# to autoscroll on page load. For example: some - website.com / #scroll - section - example
 * @example tag: <a class="btn" href="#scroll-section-example"> will scroll to: <div class="some-section" id="scroll-section-example">
 */
const ScrollTo = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domScrollLink: $('a[href*=\\#]:not([href=\\#])'),

	/** @description Initialize */
	init: function() {
		this.bindEvents();
		this.stabilizeInquiryAnchor();
		this.stabilizeMc4wpForm();
		this.hashScroll();
	},

	bindEvents: function() {
		const _this = this;

		_this.$domScrollLink.on('click', function(e) {
			const link = e.currentTarget;
			const normalizePath = (path) => (path || '/').replace(/\/$/, '') || '/';
			const isSamePage = normalizePath(link.pathname) === normalizePath(window.location.pathname)
				&& link.search === window.location.search;

			// Cross-page hash links (e.g. nav "Become a sponsor") must navigate normally.
			if (!isSamePage) {
				return;
			}

			if (!link.classList.contains('js-allow-click')) {
				e.preventDefault();
			}
			const target = $(link.hash);
			_this.scrollToTarget(target);
		});
	},

	hashScroll: function() {
		const hash = window.location.hash;

		if (!hash) {
			return;
		}

		// Deep-links with ?inquiry= rely on the browser's native hash anchor.
		if (new URLSearchParams(window.location.search).get('inquiry')) {
			return;
		}

		const target = $(hash);

		if (!target.length) {
			return;
		}

		setTimeout(() => {
			this.scrollToTarget(target, 100, 500);
		}, 500);
	},

	stabilizeInquiryAnchor: function() {
		const params = new URLSearchParams(window.location.search);

		if (!params.get('inquiry') || !window.location.hash) {
			return;
		}

		const target = document.querySelector(window.location.hash);

		if (!target) {
			return;
		}

		const align = () => {
			const top = target.getBoundingClientRect().top + window.scrollY - 100;

			window.scrollTo(0, top);
		};

		if (document.readyState === 'complete') {
			align();
		} else {
			$(window).on('load', align);
		}
	},

	/**
	 * MC4WP reloads after submit; its auto-scroll is flaky and delayed.
	 * Jump to the form immediately (no animation) and re-pin while layout settles.
	 */
	stabilizeMc4wpForm: function() {
		const headerOffset = 120;

		const getScrollEl = (formEl) => {
			if (!formEl) {
				return null;
			}

			const origin = formEl.closest('.newsletter-banner, #footer-newsletter');
			if (origin) {
				return origin;
			}

			return formEl.querySelector('input[type="email"]')
				|| formEl.querySelector('.mc4wp-response')
				|| formEl.querySelector('.mc4wp-form-fields')
				|| formEl;
		};

		const jumpToForm = (formEl) => {
			const el = getScrollEl(formEl);

			if (!el) {
				return;
			}

			const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;

			window.scrollTo(0, Math.max(0, top));
		};

		const pinToSubmittedForm = (formEl) => {
			if ('scrollRestoration' in history) {
				history.scrollRestoration = 'manual';
			}

			// Prefer our target over MC4WP's built-in auto_scroll.
			if (window.mc4wp_submitted_form) {
				window.mc4wp_submitted_form['auto_scroll'] = false;
			}

			jumpToForm(formEl);

			let resizeObserver = null;

			if (typeof ResizeObserver !== 'undefined') {
				resizeObserver = new ResizeObserver(() => jumpToForm(formEl));
				resizeObserver.observe(document.documentElement);
			}

			const stopPinning = () => {
				jumpToForm(formEl);

				if (resizeObserver) {
					resizeObserver.disconnect();
				}
			};

			if (document.readyState === 'complete') {
				stopPinning();
			} else {
				$(window).on('load', stopPinning);
			}
		};

		const stabilizeSubmitted = () => {
			const submitted = window.mc4wp_submitted_form;

			if (!submitted || !submitted.element_id) {
				return;
			}

			const formEl = document.getElementById(submitted.element_id);

			if (!formEl) {
				return;
			}

			pinToSubmittedForm(formEl);
		};

		stabilizeSubmitted();

		if (window.mc4wp && window.mc4wp.forms && typeof window.mc4wp.forms.on === 'function') {
			window.mc4wp.forms.on('submitted', (form) => {
				if (form && form.element) {
					jumpToForm(form.element);
				}
			});
		}
	},

	scrollToTarget: function(target, offset = 100, scrollSpeed = 1200) {
		if (target.length) {
			const isNewsletterTarget = target.is('.cta-cards__newsletter') || target.closest('.cta-cards__newsletter').length > 0;
			const scrollTarget = isNewsletterTarget
				? target.closest('.cta-cards__item').find('.cta-cards__bg').first()
				: target;
			const targetOffset = isNewsletterTarget ? 100 : offset;

			$('html,body').animate({
				scrollTop: scrollTarget.offset().top - targetOffset
			}, scrollSpeed);
		}
	}
};

export default ScrollTo;
